<template>
  <div class="relative col-12">
    <select 
      :value="value"
      :id="`select-${id}`" 
      :ref="id" 
      :disabled="disabled" 
      class="form-input"
      :class="{ 'red-border': valid }"
      @input="$emit('update:value', $event.target.value)"
    >
      <option v-if="placeholder" :value="null" disabled selected>
        {{ getReferencelabel(placeholder) }}
      </option>
      <option v-for="(option, optionIndex) in options" :key="optionIndex" :disabled="disabled" :value="option.value">
        {{ option.text }}
      </option>
    </select>
    <span class="absolute dark-blue pointer" style="right: 12px; top: 50%; transform: translateY(-50%)">
      <i class="icon icon-chevron-down"></i>
    </span>
  </div>
</template>

<script setup>
import { getReferencelabel } from '@/mixins/utils';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  value: {
    type: [String, Number, null],
    default: null,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  valid: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:value']);
</script>